import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  Alert,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItem,
  Box,
} from '@mui/material'

import useStyles from './styles'

const CompleteInfoItem = ({
  icon,
  title,
  subtitle,
  secondaryItem,
  error,
  sx,
}) => {
  const classes = useStyles()

  return (
    <Box
      className={clsx(classes.completeInfo, {
        [classes.error]: !!error,
      })}
      sx={sx}
    >
      <ListItem className={classes.completeInfo} alignItems="flex-start">
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={title} secondary={subtitle} />
        {secondaryItem ? (
          <ListItemSecondaryAction className={classes.secondaryItem}>
            {secondaryItem}
          </ListItemSecondaryAction>
        ) : null}
      </ListItem>
      {error ? (
        <Alert severity="error" className={classes.alert}>
          {error}
        </Alert>
      ) : null}
    </Box>
  )
}

CompleteInfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  secondaryItem: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  error: PropTypes.string,
  icon: PropTypes.node,
  sx: PropTypes.object,
}

export default CompleteInfoItem
